import { useMemo } from "react";
import { DEFAULT_COUNTRY_CODE_LOWERCASE } from "@nf/constants";
import { useRouter } from "next/router";

export const useCountry = () => {
  const router = useRouter();
  const { country: countryQuery } = router.query;

  const country = useMemo(() => {
    if (countryQuery) {
      return countryQuery as string;
    }

    return DEFAULT_COUNTRY_CODE_LOWERCASE;
  }, [countryQuery]);

  return country;
};
